<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>系统管理</el-breadcrumb-item>
            <el-breadcrumb-item>设置管理员</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <!--卡片视图区-->
        <el-card>
            <!--搜索与添加区域-->
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-input placeholder="请输入管理员帐号" clearable v-model="queryInfo.query" @clear="getList()">
                        <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="12"><el-button type="primary" @click="addDialogVisible = true" v-permission="'btn:admin:add'">添加管理员</el-button></el-col>
            </el-row>
            <!--搜索与添加区域-->
            <!--商品列表区域-->
            <el-table :data="list" style="width: 100%" stripe size="middle" height="700">
                <el-table-column label="ID" type="index" width="100"></el-table-column>
                <el-table-column label="管理员名称" prop="name" width="150"></el-table-column>
                <el-table-column label="帐号" prop="username" width="150"></el-table-column>
                <!-- <el-table-column label="密码" prop="password" width="150"></el-table-column> -->
                <el-table-column label="角色" prop="roleName" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column label="状态" prop="status" width="100">
                    <template slot-scope="scope">
                       <el-tag v-if="scope.row.status=='0'"  type="success">正常</el-tag>
                       <el-tag v-if="scope.row.status=='1'" type="info">禁用</el-tag>
                       <!-- <el-tag v-else-if="scope.row.isopen=='3'" type="warning">装修中</el-tag> -->
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <!--作用域插槽-->
                    <template slot-scope="scope" v-if="scope.row.username !='admin'">
                        <!-- {{scope.row}} -->
                        <!-- 添加调试信息，显示行数据 -->
                        <!-- 使用自定义方法记录行数据 -->
                        <el-button type="success" icon="el-icon-edit" size="mini" @click="EditMerchant(scope.row)" v-permission="'btn:admin:edit'">编辑</el-button>
                        <el-button type="danger" icon="el-icon-delete" size="mini" @click="DelMerchant(scope.row)" v-permission="'btn:admin:delete'">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--商品列表区域-->
             <!--分页区域-->
             <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum" :page-sizes="[20,50,500,1000]"  :page-size="queryInfo.pagesize" 
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
            <!--分页区域-->
            <!--添加对话框-->
            <el-dialog title="添加管理员" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed">
                <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="100px">
                    <el-form-item label="用户名" prop="username">
                        <el-input v-model="addForm.username"  placeholder="请输入用户名"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password">
                        <el-input v-model="addForm.password" type="password"  placeholder="请输入密码" show-password></el-input>
                    </el-form-item>
                    <el-form-item label="管理员名称" prop="name">
                        <el-input v-model="addForm.name" placeholder="请输入管理员名称"></el-input>
                    </el-form-item>
                    <el-form-item label="角色设置" prop="roleId">
                        <el-select v-model="addForm.roleId" placeholder="请选择角色">
                            <el-option v-for="item in roles" :key="item.id" :label="item.roleName" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-switch active-value="1" inactive-value="0" v-model="addForm.status"></el-switch>
                        <span style="padding-left: 10px;" v-if="addForm.status == '0'">正常</span>
                        <span style="padding-left: 10px;" v-if="addForm.status == '1'">禁用</span>
                    </el-form-item>
                    <el-form-item label="授权IP地址" prop="ipAddress">
                        <el-input v-model="currentIPAddress" readonly placeholder="系统自动获取"></el-input>
                        <div style="font-size: 12px; color: #999; margin-top: 5px;">
                            添加管理员时将自动绑定当前设备的IP地址
                        </div>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="AddMerchant">确 定</el-button>
                </span>
            </el-dialog>
            <!--添加对话框-->
            <!--编辑对话框-->
            <el-dialog title="编辑管理员" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed">
                <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="100px">
                    <el-form-item label="用户名" prop="username">
                        <el-input v-model="editForm.username" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password1">
                        <el-input v-model="editForm.password1"  placeholder="如果为空则使用原密码"></el-input>
                    </el-form-item>
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model="editForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="角色" prop="roleId">
                        <div style="display: flex; align-items: center;">
                            <el-select v-model="editForm.roleId" placeholder="请选择角色" style="width: 80%;">
                                <el-option v-for="item in roles" :key="item.id" :label="item.roleName" :value="item.id"></el-option>
                                <el-option v-if="roles.length === 0" label="暂无角色数据" :value="null" disabled></el-option>
                            </el-select>
                            <el-button type="primary" size="small" style="margin-left: 10px;" @click="addRoleDialogVisible = true">新建角色</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-switch active-value="1" inactive-value="0" v-model="editForm.status"></el-switch>
                        <span style="padding-left: 10px;" v-if="editForm.status == '0'">正常</span>
                        <span style="padding-left: 10px;" v-if="editForm.status == '1'">禁用</span>
                    </el-form-item>
                    
                    <!-- IP地址管理 -->
                    <el-form-item label="IP地址管理">
                        <div v-if="editForm.username === 'admin'" style="margin-bottom: 10px;">
                            <el-input v-model="currentIPAddress" readonly placeholder="当前登录设备IP地址">
                                <template slot="prepend">当前设备</template>
                            </el-input>
                            <div style="font-size: 12px; color: #409EFF; margin-top: 5px;">
                                admin账号不受IP地址限制，可在任意设备登录
                            </div>
                        </div>
                        
                        <div v-else>
                            <el-input v-model="editForm.machinecode" placeholder="第一个授权IP地址" style="margin-bottom: 10px;">
                                <template slot="prepend">IP地址1</template>
                                <el-button slot="append" @click="resetIPAddress(1)" type="danger" size="small">清除</el-button>
                            </el-input>
                            
                            <el-input v-model="editForm.machinecode2" placeholder="第二个授权IP地址" style="margin-bottom: 10px;">
                                <template slot="prepend">IP地址2</template>
                                <el-button slot="append" @click="resetIPAddress(2)" type="danger" size="small">清除</el-button>
                            </el-input>
                            
                            <el-button @click="setCurrentIPAddress" type="primary" size="small" style="margin-right: 10px;">
                                设置当前设备IP地址
                            </el-button>
                            
                            <div style="font-size: 12px; color: #999; margin-top: 10px;">
                                <div>• 每个账号最多可设置2个授权IP地址</div>
                                <div>• 只能在已授权的IP地址上登录</div>
                                <div>• 如需在新设备登录，请先清除IP地址</div>
                            </div>
                        </div>
                    </el-form-item>
                    
                    <!-- IP地址说明 -->
                    <el-form-item label="IP地址说明">
                        <el-collapse>
                            <el-collapse-item title="关于IP地址授权的说明" name="ip-help">
                                <div style="font-size: 13px; line-height: 1.6;">
                                    <p><strong>IP地址授权机制</strong></p>
                                    <p>• 系统使用IP地址作为设备识别标识</p>
                                    <p>• 每个管理员账号最多可授权2个IP地址</p>
                                    <p>• 只有在授权的IP地址上才能登录系统</p>
                                    
                                    <p><strong>注意事项</strong></p>
                                    <p>• 如果您的网络使用动态IP，IP地址可能会发生变化</p>
                                    <p>• 在IP地址变化后，需要重新设置授权IP地址</p>
                                    <p>• 建议在稳定的网络环境下使用本系统</p>
                                    
                                    <p style="color: #e6a23c; margin-top: 15px;">
                                        <strong>提示：</strong>当前IP地址会自动获取，无需手动输入。如遇到登录问题，请联系系统管理员重置IP地址授权。
                                    </p>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                    </el-form-item>
                    
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="editDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="EditMerchantSave(editForm.id)">确 定</el-button>
                </span>
            </el-dialog>
            <!--编辑对话框-->
            
            <!-- 新建角色对话框 -->
            <el-dialog title="新建角色" :visible.sync="addRoleDialogVisible" width="30%" @close="addRoleDialogClosed">
                <el-form :model="addRoleForm" :rules="addRoleFormRules" ref="addRoleFormRef" label-width="80px">
                    <el-form-item label="角色名称" prop="roleName">
                        <el-input v-model="addRoleForm.roleName"></el-input>
                    </el-form-item>
                    <el-form-item label="角色描述" prop="description">
                        <el-input type="textarea" v-model="addRoleForm.description"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addRoleDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addRoleSave">确 定</el-button>
                </span>
            </el-dialog>
        </el-card>
    </div>
</template>
<script>
export default {
    data() {
        return{
            imgURL:this.GLOBAL.imgURL,
            queryInfo: {
                query: '',
                pagenum: 1,
                pagesize: 20
            },
            total:0,
            list: [],
            originalList: [], // 保存原始数据，包含pk字段
            // 角色列表
            roles: [],
            // 权限列表
            perids: [],  // 保留兼容旧代码
            // 新建角色对话框可见性
            addRoleDialogVisible: false,
            // 新建角色表单
            addRoleForm: {
                roleName: '',
                description: ''
            },
            // 新建角色表单验证规则
            addRoleFormRules: {
                roleName: [
                    { required: true, message: '请输入角色名称', trigger: 'blur' }
                ]
            },
            addDialogVisible:false,
            editDialogVisible:false,
            addForm:{
                 username:'',
                 password:'',
                 name:'',
                 telephone:'',
                 storeid:'',
                 roleId: null,
                 perid:[],  // 保留兼容旧代码
                 status:''
            },
            currentIPAddress: '', // 当前IP地址
             //编辑表单数据
             editForm:{
                username:'',
                password1:'',
                name:'',
                telephone:'',
                storeid:'',
                roleId: null,
                perid:[],
                status:'',
                machinecode:'',
                machinecode2:''
            },
            //添加表单验证规则
            addFormRules:{
                username:[
                    { required: true, message: '请输入用户名', trigger: 'blur' },
                    { min: 5, max: 20, message: '用户名长度在 5 到 20 个字符', trigger: 'blur' }
                ],
                password:[
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
                ],
                name:[
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                telephone:[
                    { required: true, message: '请输入手机号', trigger: 'blur' }
                ],
                storeid:[
                    { required: true, message: '请输入选择关联门店', trigger: 'blur' }
                ]
            },
            editFormRules:{
                name:[
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                telephone:[
                    { required: true, message: '请输入手机号', trigger: 'blur' }
                ],
                storeid:[
                    { required: true, message: '请输入选择关联门店', trigger: 'blur' }
                ]
            },
        }
        
    },
    async created() {
         this.getClass()
         this.getList()
    },
    async mounted(){
        this.addForm.admin_token = window.sessionStorage.getItem('admin_token')
        
        // 获取当前IP地址用于显示
        try {
            const { getIPAddress } = await import('@/utils/ipAddress.js');
            this.currentIPAddress = await getIPAddress();
        } catch (error) {
            console.error('获取IP地址失败:', error);
            this.currentIPAddress = '获取失败';
        }
    },
    
    methods:{
        // 关闭新建角色对话框时重置表单
        addRoleDialogClosed() {
            this.$refs.addRoleFormRef.resetFields();
        },
        
        // 保存新建的角色
        addRoleSave() {
            this.$refs.addRoleFormRef.validate(async valid => {
                if (!valid) return;
                
                try {
                    // 添加管理员token和机器码
                    const { generateMachineCode } = await import('@/utils/machineCode.js');
                    const machineCode = generateMachineCode();
                    
                    const roleData = {
                        ...this.addRoleForm,
                        admin_token: window.sessionStorage.getItem('admin_token'),
                        machineCode: machineCode
                    };
                    
                    console.log('Saving new role:', roleData);
                    
                    // 发送请求创建新角色
                    const { data: res } = await this.$http.post('role/add', roleData);
                    
                    if (res.code === 200 || res.status === 0) {
                        this.$message.success('新建角色成功');
                        this.addRoleDialogVisible = false;
                        // 重新获取角色列表
                        await this.getClass();
                    } else {
                        this.$message.error(res.message || '新建角色失败');
                    }
                } catch (error) {
                    console.error('Error creating role:', error);
                    this.$message.error('新建角色失败');
                }
            });
        },
        
        async getClass(){
            try {
                // 获取角色列表
                const { data: res } = await this.$http.get('role/list')
                console.log('Role list response:', res);
                
                // 兼容不同的API响应格式
                if (res.code === 200 || res.status === 1) {
                    this.roles = res.data || [];
                    console.log('Roles loaded:', this.roles);
                } else {
                    console.error('Failed to load roles:', res);
                    this.$message.error('加载角色列表失败');
                }
                
                // 保留获取权限列表，兼容旧代码
                const { data: perRes } = await this.$http.get('getperlist/')
                this.perids = perRes.data || [];
            } catch (error) {
                console.error('Error loading roles and permissions:', error);
                this.$message.error('加载角色和权限数据失败');
            }
        },
        
        // 清除IP地址
        resetIPAddress(codeNumber) {
            this.$confirm('确定要清除这个IP地址吗？清除后该IP地址将无法登录此账号。', '确认清除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (codeNumber === 1) {
                    this.editForm.machinecode = '';
                    this.$message.success('第一个IP地址已清除');
                } else if (codeNumber === 2) {
                    this.editForm.machinecode2 = '';
                    this.$message.success('第二个IP地址已清除');
                }
            }).catch(() => {
                this.$message.info('已取消清除');
            });
        },
        
        // 设置当前设备IP地址
        async setCurrentIPAddress() {
            try {
                console.log('开始获取IP地址...');
                const { getIPAddress } = await import('@/utils/ipAddress.js');
                const ipAddress = await getIPAddress();
                
                console.log('获取的IP地址:', ipAddress);
                console.log('当前editForm:', this.editForm);
                
                if (!ipAddress) {
                    this.$message.error('IP地址获取失败，请重试');
                    return;
                }
                
                // 检查是否已经设置过这个IP地址
                if (this.editForm.machinecode === ipAddress || this.editForm.machinecode2 === ipAddress) {
                    this.$message.warning('当前IP地址已经绑定过');
                    return;
                }
                
                // 选择设置到哪个位置
                if (!this.editForm.machinecode || this.editForm.machinecode.trim() === '') {
                    this.$set(this.editForm, 'machinecode', ipAddress);
                    console.log('设置第一个IP地址:', this.editForm.machinecode);
                    this.$message.success('已设置为第一个IP地址');
                } else if (!this.editForm.machinecode2 || this.editForm.machinecode2.trim() === '') {
                    this.$set(this.editForm, 'machinecode2', ipAddress);
                    console.log('设置第二个IP地址:', this.editForm.machinecode2);
                    this.$message.success('已设置为第二个IP地址');
                } else {
                    this.$confirm('两个IP地址位置都已占用，是否替换第一个IP地址？', '确认替换', {
                        confirmButtonText: '替换第一个',
                        cancelButtonText: '替换第二个',
                        distinguishCancelAndClose: true,
                        type: 'warning'
                    }).then(() => {
                        this.$set(this.editForm, 'machinecode', ipAddress);
                        console.log('替换第一个IP地址:', this.editForm.machinecode);
                        this.$message.success('已替换第一个IP地址');
                    }).catch((action) => {
                        if (action === 'cancel') {
                            this.$set(this.editForm, 'machinecode2', ipAddress);
                            console.log('替换第二个IP地址:', this.editForm.machinecode2);
                            this.$message.success('已替换第二个IP地址');
                        }
                    });
                }
                
                // 强制更新视图
                this.$forceUpdate();
                
            } catch (error) {
                console.error('获取IP地址失败:', error);
                this.$message.error('获取IP地址失败: ' + error.message);
            }
        },
        async getList() {
            try {
                const { data:res } = await this.$http.get('managerlist/',{ params: this.queryInfo })
                console.log('API response:', res);
                
                if(res.status == 1){
                    this.total = res.data.totalCount;
                    
                    // 处理数据前先打印原始数据结构
                    console.log('Original list data:', JSON.stringify(res.data.list));
                    
                    // 将原始数据保存下来，以便在操作按钮中使用
                    this.originalList = res.data.list;
                    
                    this.list = res.data.list.map((v, index) => {
                        console.log(`Processing item ${index}:`, v);
                        
                        // 处理返回的数据
                        const fields = v.fields ? {...v.fields} : {...v}; // 使用浅拷贝避免引用问题
                        
                        // 确保角色名称显示正确
                        if (!fields.roleName && fields.roleId) {
                            // 如果没有roleName但有roleId，尝试从roles中获取角色名称
                            const role = this.roles.find(r => r.id === fields.roleId);
                            if (role) {
                                fields.roleName = role.roleName;
                            }
                        }
                        
                        // 确保id字段存在
                        if (v.pk) {
                            fields.pk = v.pk;
                            fields.id = v.pk;
                        } else if (fields.id) {
                            // 如果已经有id字段，确保它被保留
                            console.log(`Item ${index} has id:`, fields.id);
                        } else {
                            console.error(`Item ${index} has no id!`, fields);
                        }
                        
                        // 打印完整的字段信息
                        console.log(`Item ${index} fields:`, fields);
                        
                        return fields;
                    });
                    
                    // 打印处理后的列表数据
                    console.log('Processed list data:', this.list);
                }
            } catch (error) {
                console.error('Error fetching manager list:', error);
            }
        },
        handleSizeChange(newSize){
          // console.log(newSize)
           this.queryInfo.pagesize = newSize
           this.getList()
       },
       handleCurrentChange(newPage){
          // console.log(newPage)
           this.queryInfo.pagenum = newPage
           this.getList()
       },
       addDialogClosed(){
            this.$refs.addFormRef.resetFields()
       },
       editDialogClosed(){
            this.$refs.editFormRef.resetFields()
       },
       AddMerchant(){
        this.$refs.addFormRef.validate( async valid=>{
                if (!valid) return
                const { data:res } = await this.$http.post('manageradd/',this.addForm)
                if(res.status===0)
                {
                    this.$message.success('添加管理员成功！')
                    this.addDialogVisible = false
                    this.getList()
                }
                if(res.status == 1){
                    this.$message.error('此用户名已存在')
                }
              })
       },
       async EditMerchant(row){
           try {
               // 打印整行数据，查看数据结构
               console.log('Row data received in EditMerchant:', row);
               
               // 从行数据中提取ID
               const id = row.pk || row.id;
               
               if (!id) {
                   console.error('编辑管理员失败：ID不能为空', row);
                   this.$message.error('编辑失败：ID不能为空');
                   return;
               }
               
               console.log('Editing manager with ID:', id);
               // 使用GET请求通过URL路径参数获取管理员信息
               const { data: res } = await this.$http.get(`managerinfo/${id}`)
               console.log('Manager info response:', res);
                              this.editDialogVisible = true
                this.editForm = res;
                
                // 打印完整的管理员信息
                console.log('Complete manager info:', res);
                
                // 处理权限字段，兼容旧代码
                if (res.perid) {
                    try {
                        this.editForm.perid = JSON.parse(res.perid.replace(/'/g, '"'))
                    } catch (e) {
                        console.error('Error parsing perid:', e);
                        this.editForm.perid = []
                    }
                } else {
                    this.editForm.perid = []
                }
                
                // 处理机器码字段回显
                this.editForm.machinecode = res.machinecode || '';
                this.editForm.machinecode2 = res.machinecode2 || '';
                
                // 处理角色ID
                if (res.roleId) {
                    console.log('Setting roleId:', res.roleId);
                    this.editForm.roleId = res.roleId;
                    
                    // 检查角色列表是否已加载
                    if (!this.roles || this.roles.length === 0) {
                        console.log('Roles not loaded yet, fetching roles...');
                        await this.getClass(); // 确保角色列表已加载
                    }
                    
                    // 查找对应的角色名称
                    const role = this.roles.find(r => r.id === res.roleId);
                    if (role) {
                        console.log('Found role name:', role.roleName);
                        this.editForm.roleName = role.roleName;
                    } else {
                        console.warn('Role not found for ID:', res.roleId);
                    }
                } else {
                    console.log('No roleId provided in manager info');
                }
               
               this.editForm.admin_token = window.sessionStorage.getItem('admin_token')
           } catch (error) {
               console.error('Error fetching manager info:', error);
               this.$message.error('获取管理员信息失败');
           }
       },
       EditMerchantSave(id){
           this.$refs.editFormRef.validate(async valid => {
                if (!valid) return
                const { data: res } = await this.$http.post('manageredit/' + id,this.editForm)
                if (res.status === 0) {
                    this.$message.success('管理员修改成功')
                    this.editDialogVisible = false
                    this.getList()
                }
            })
       },
       async DelMerchant(row){
                try {
                    // 打印整行数据，查看数据结构
                    console.log('Row data received in DelMerchant:', row);
                    
                    // 从行数据中提取ID
                    const id = row.pk || row.id;
                    
                    if (!id) {
                        console.error('删除管理员失败：ID不能为空', row);
                        this.$message.error('删除失败：ID不能为空');
                        return;
                    }
                    
                    console.log('Deleting manager with ID:', id);
                    
                    const confirmResult = await this.$confirm('是否要删除此信息吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).catch(err => err)

                    if (confirmResult !== 'confirm'){
                        return this.$message.info('已取消删除！')
                    }
                    
                    // 使用GET请求通过URL路径参数删除管理员
                    const { data: res } = await this.$http.get(`managerdel/${id}`)
                    console.log('Delete response:', res);
                    
                    if (res.status === 0) { 
                        this.$message({message: '删除成功！',type: 'success'})
                    } else {
                        this.$message.error(res.message || '删除失败')
                    }
                    
                    // 刷新列表
                    this.getList()
                } catch (error) {
                    console.error('Error deleting manager:', error);
                    this.$message.error('删除管理员失败');
                }
       },
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
    }
    .el-breadcrumb{
        width: 100%;
    }
    el-table__row>td {
    border: none;
    }

    .el-table::before {
        height: 0px;
    }

</style>